// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.no-margin[data-v-3a6e5add] {\n        margin: 0rem !important;\n}\n.embedded-page-settings-form[data-v-3a6e5add] {\n        padding: 0 18px;\n}\n", ""]);
// Exports
module.exports = exports;
